import React from "react"
import _ from "lodash"
import { formatDate, isValidDate, parseDate } from "data/lib/dates"
import { localizeNum, isValidNumber } from "data/lib/numbers"

type DateFieldProps = {
  rowData: object
  field: string|string[]
  withoutDays?: boolean
  allowRelative?: boolean
}

const format = (format, withoutDays) => s =>
  formatDate(parseDate(s), format, withoutDays)

const DateField = (props: DateFieldProps) => {
  const _format = format(
    props.withoutDays ? "MM/YYYY" : "MM/DD/YYYY",
    props.withoutDays
  )

  let displayValue = ""
  let propValue = _.get(props.rowData, props.field)
  if(propValue && isValidDate(propValue)) displayValue = _format(propValue)
  if(propValue && props.allowRelative && isValidNumber(propValue)) displayValue = localizeNum(propValue)

  return <span>{displayValue}</span>
}

export default DateField
